import { Link } from "react-router-dom";
import { topics } from "@/mocks/site";
import { getMoviesByIds } from "@/utils/movie";
import SectionHeading from "@/components/feature/SectionHeading";

export default function TopicSection() {
  return (
    <section id="topics" className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="Collections"
          title="热门影视专题推荐"
          subtitle="编辑精选的主题合集，带你从不同视角重新认识这些作品"
          moreLabel="全部专题"
          morePath="/category"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {topics.map((t) => {
            const list = getMoviesByIds(t.movieIds).slice(0, 3);
            return (
              <Link
                key={t.id}
                href={`/category?tag=${encodeURIComponent(t.tag)}`}
                to={`/category?tag=${encodeURIComponent(t.tag)}`}
                className="group relative rounded-lg overflow-hidden border border-background-200/70 bg-background-50 cursor-pointer"
              >
                <div className="flex flex-col sm:flex-row">
                  <div className="relative w-full sm:w-[210px] h-[190px] sm:h-auto shrink-0 overflow-hidden bg-background-200">
                    <img
                      src={t.cover}
                      alt={`${t.title} 专题封面`}
                      title={`${t.title} 影视专题`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent sm:bg-gradient-to-r"></div>
                  </div>
                  <div className="flex-1 p-5 md:p-6 flex flex-col">
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-700 mb-2">
                      <i className="ri-bookmark-3-line"></i>
                      专题合集
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                      {t.title}
                    </h3>
                    <p className="mt-1 text-sm text-primary-600/90">{t.subtitle}</p>
                    <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">{t.desc}</p>
                    <div className="mt-4 flex items-center gap-2 flex-wrap">
                      {list.map((m: any) => (
                        <span
                          key={m.id}
                          className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900"
                        >
                          {m.title}
                        </span>
                      ))}
                      <span className="text-xs text-primary-600 font-medium inline-flex items-center gap-0.5">
                        查看合集
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}